import { BrowserRouter, Route, Routes } from "react-router-dom";

import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";

import RouteScrollToTop from "./helper/RouteScrollToTop";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ChangePasswordPage from "./pages/ChangePasswordPage";
import ClientsPage  from "./pages/ClientsPage";
import PortfolioDetailsPage from "./pages/PortfolioDetailsPage";
import CopperPage from "./pages/CopperPage";
import { TimezoneProvider } from "./hook/useTimezone";


function App() {
  return (
    <TimezoneProvider>
      <BrowserRouter>
        <RouteScrollToTop />
        <Routes>
          <Route exact path="/" element={<SignInPage />} />
          <Route exact path="/clients" element = {<ClientsPage/>} />
          <Route exact path="/portfolio/:encodedId" element = {<PortfolioDetailsPage />} />
          <Route exact path ="/change-password" element = {<ChangePasswordPage/>} />
          <Route exact path="/sign-up" element={<SignUpPage />} />
          <Route exact path="/copper/:section" element={<CopperPage />} />
          <Route exact path="*" element={<ErrorPage />} />
        </Routes>
        <NotificationContainer />
      </BrowserRouter>
    </TimezoneProvider>
  );
}

export default App;
